import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Popover } from 'primeng/popover';
import { toggleEllipsisPopover } from 'src/app/modules/crm/shared/utilities/ellipsis-popover.util';
import { ellipsisHeaderOptions } from 'src/app/modules/crm/shared/constants/ellipsis-options';
import { FormFieldControlService } from 'src/app/modules/crm/services/form-field-control.service';
import { FormField } from 'src/app/modules/crm/shared/form-field/form-field';
import { ProblemService } from '../problem.service';
import { ContractFormFieldService } from 'src/app/modules/crm/services/contract-form-field.service';
import { copy } from 'src/app/modules/crm/shared/utilities/common-utilities';

@Component({
  standalone: false,
  selector: 'theft-problem',
  templateUrl: 'theft-problem.template.html',
  styleUrls: ['./theft-problem.scss'],
  providers: [FormFieldControlService, ContractFormFieldService],
})
export class TheftProblemComponent {
  formFields: FormField<string>[] = [];
  formFieldsPart1: FormField<string>[] = [];
  form: FormGroup;
  selectedItem: any;
  ellipsisHeaderOptions: any[] = copy(ellipsisHeaderOptions);
  cols: any[];
  colsTs: any[];
  problemInfo: any[];
  problemTs: any[];
  contactInfo: any[];
  constructor(
    private qcs: FormFieldControlService,
    private service: ProblemService,
    private contractFormFieldService: ContractFormFieldService,
  ) {
    this.service.getTheftLossFields().subscribe((data: FormField<string>[]) => {
      this.formFields = data;
      this.formFieldsPart1 = this.formFields.slice(0, 11);
      this.form = this.qcs.toFormGroup(this.formFields);
    });
    this.contractFormFieldService
      .getContactInfoFields()
      .subscribe((contactInfo) => (this.contactInfo = contactInfo));
    this.cols = [
      { field: 'model', header: 'MODEL #' },
      { field: 'ofClaims', header: '# OF CLAIMS' },
      { field: 'sameFailure', header: 'SAME FAILURE' },
    ];
    this.colsTs = [
      { field: 'fixed', header: 'FIXED' },
      { field: 'notFixed', header: 'NOT FIXED' },
      { field: 'troubleshooting', header: 'TROUBLESHOOTING' },
      { field: 'success', header: 'SUCCESS' },
    ];
    this.service.getStandardInfo().subscribe((data) => {
      this.problemInfo = data;
    });
    this.service.getTroubleshootInfo().subscribe((data) => {
      this.problemTs = data;
    });
  }

  onSubmit() {
    // functionality for on submit
  }

  ellipsisClick(event, item, Popover: Popover) {
    this.selectedItem = item;
    toggleEllipsisPopover(event, Popover);
  }

  ellipsisOptionClick(event) {
    // ellipsis functionality goes here
  }
}
